module.exports = __webpack_public_path__ + "img/logo-brand-cliff.dfcfed8d.svg";